import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Input, Table } from 'reactstrap';
import { actionLogClear } from './actions';
import { actionLogEntitySelector } from './selectors';

export const ActionLog: FC<{}> = () => {
    const entities = useSelector(actionLogEntitySelector);

    const dispatch = useDispatch();

    const [selectedOnly, setSelectedOnly] = useState(false);
    const [selected, setSelected] = useState<{ [name: string]: boolean }>({});
    const [filter, setFilter] = useState('');

    const toggleKey = (key: string) => {
        const select = { ...selected, [key]: !selected[key] };
        setSelected(select);
    };

    const clearAllLogs = () => {
        Object.keys(entities).forEach(key => dispatch(actionLogClear(key)));
    };

    const renderActionLog = (key: string, count: number) => {
        const isSelected = selected[key];
        if ((!selectedOnly || selected[key]) && key.toLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1) {
            return (
                <tr key={key}>
                    <td>{key}</td>
                    <td>{count}</td>
                    <td>
                        <Button color="link" onClick={() => toggleKey(key)}>
                            {isSelected ? 'hide' : 'show'}
                        </Button>
                    </td>
                    <td>
                        <Button color="link" onClick={() => dispatch(actionLogClear(key))}>
                            clear
                        </Button>
                    </td>
                </tr>
            );
        } else {
            return null;
        }
    };

    return (
        <div>
            <Button color="link" onClick={() => setSelectedOnly(!selectedOnly)}>
                {selectedOnly ? 'alle anzeigen' : 'ausgewählte anzeigen'}
            </Button>
            <Button color="link" onClick={() => clearAllLogs()}>
                Clear all
            </Button>
            <Form >
                <Input
                    value={filter}
                    onChange={e => setFilter(e.currentTarget.value)}
                    bsSize="sm"
                    placeholder="Filter"
                />
            </Form>
            <Table>
                <tbody>{entities && Object.keys(entities).map(key => renderActionLog(key, entities[key]))}</tbody>
            </Table>
        </div>
    );
};
